import { useState, useEffect } from 'react';
import api from '../../../services/api';

// P2 Faz 1 — Bileşen 2 (Bağlam Paneli). TEK uç (BE dört kaynağı kendi
// kompoze eder; FE'de Promise.all YOK):
//   GET v1/performance/context/{periodId}/{employeeId}
//        → { employeeName, goals[], history[], feedback[], activePipStatus, activeIdpStatus }
//        [ModuleAuthorize("PM","Read")] + ekip-kapsamı (doğrudan rapor VEYA enterpriseAdmin)
//
// skipErrorToast: panel YARDIMCI bir yüzeydir — kapsam dışı (403) ya da
// bulunamayan (404) bir çalışan için modalın üstüne hata toast'ı basmak
// yanıltıcı olurdu; panel sessizce "bilgi yok" durumuna düşer
// (calibration/config'teki getFeedbackSummary ile aynı gerekçe).
export const usePerformanceContext = (periodId, employeeId) => {
  const [context, setContext] = useState(null);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (!periodId || !employeeId) {
      setContext(null);
      return undefined;
    }

    let cancelled = false;
    setFetching(true);
    api.get(`/v1/performance/context/${periodId}/${employeeId}`, { skipErrorToast: true })
      .then((res) => {
        if (cancelled) return;
        setContext(res.data?.status ? res.data.data : null);
      })
      .catch(() => { if (!cancelled) setContext(null); })
      .finally(() => { if (!cancelled) setFetching(false); });

    return () => { cancelled = true; };
  }, [periodId, employeeId]);

  return { context, fetching };
};

// OKR hedefinde tek satırlık özet skor: aktif KR'lerin YÖNETİCİ puanı ortalaması
// (1-5). Hiç puanlanmamışsa null → panelde "-" gösterilir. KPI hedefinde bunun
// yerine completionPct kullanılır (bkz. PerformanceContextPanel).
export const okrAverageScore = (goal) => {
  const scores = (goal?.keyResults || [])
    .map((kr) => kr.managerScore)
    .filter((s) => s != null)
    .map(Number);
  if (scores.length === 0) return null;
  return Math.round((scores.reduce((a, b) => a + b, 0) / scores.length) * 10) / 10;
};
